import React, { useRef, useState, useId } from "react";
import './PortalUsersLogin.scss';
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import validator from 'validator';
import { useLocation, useNavigate } from "react-router-dom";
import emailjs from 'emailjs-com';
import { v4 as uuidv4 } from 'uuid';

export default function PortalUsersLogin({ setUpdateApp, showsetNotification, showsetNotificationType }) {
    // Helpers
    const [Rendder, setRendder] = useState(false);
    const navigate = useNavigate();
    const url = new URL(window.location.href);
    // User Info
    const [Email, setEmail] = useState(false);
    const [IsEmailExistBoolen, setIsEmailExistBoolen] = useState(false);
    const [LoadingEmail, setLoadingEmail] = useState(false);
    const [LoadingEmail2, setLoadingEmail2] = useState(false);
    const [EmailCode, setEmailCode] = useState(false);
    const [StorageCodeLocal, setStorageCode] = useState(Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000);

    const timestampInMs = Date.now();
    const [UserInfo, setUserInfo] = useState({
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        Email: '',
        Code: '',
        UserDateCreated: timestampInMs,
        LastLoginUserDate: timestampInMs,
        UserIP: "",
        UserAgent: navigator.userAgent,
        UserProfilePicture: null
    });


    // intervalFun()
    const containerRef2 = useRef(null);
    const scrollRight = (pages, leftOrReight) => {
        setRendder(a => !a)
        const container = containerRef2.current;
        if (container && leftOrReight == true) {
            const scrollAmount = (container.clientWidth * pages);
            container.scrollLeft = scrollAmount;
        } else if (container && leftOrReight == false) {
            const scrollAmount = (container.clientWidth * pages - container.clientWidth - container.clientWidth);
            container.scrollLeft = scrollAmount;
        }
        setRendder(a => !a)

    };

    // Send From Titan SMTP Email JS HnadyBy.com and check if usser exist
    function sendEmail(e) {

        window.scrollTo(0, 0)
        e.preventDefault();
        (async () => {
            if (UserInfo.Email && UserInfo.Email.length && validator.isEmail(UserInfo.Email)) {

                setLoadingEmail(true)
                setRendder(a => !a)
                scrollRight(1, true)
                const res1 = await fetch(`https://bhocs-10ec.restdb.io/rest/handyby-users?q={"UserEmail":"${UserInfo.Email.toLocaleLowerCase()}"}&h={"$fields": {"UserEmail": 1, "UserID": 1} }`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'apikey': '6714a668e2b4472fa2c2d036'
                    }
                });
                const data1 = await res1.json()
                setLoadingEmail(false)
                window.scrollTo(0, 0)
                setRendder(a => !a)
                showsetNotificationType('emailsent')
                showsetNotification(true)
                if (data1.length) {
                    setStorageCode(StorageCodeLocal)
                    window.scrollTo(0, 0)
                    setEmail(false)
                    setRendder(a => !a)

                    emailjs.sendForm('service_bps6foc', 'template_4h1sufs', e.target, 'QeqW-bXHRNjRmhZ6I')
                        .then((result) => {
                            handleClickFocusOnInputConfirmedCode();
                        }, (error) => {
                            console.log("error", error.text);
                        });
                }
            } else {
                setEmail(true)
                setRendder(a => !a)

            }
        })()

    }

    const inputRef = useRef(null);
    const handleClickFocusOnInputConfirmedCode = () => {
        inputRef.current.focus();
    };
    // useEffect
    useEffect(() => {
        (async () => {
            scrollRight(0, false)
            const response = await fetch('https://geolocation-db.com/json/');
            const data = await response.json();
            UserInfo.UserIP = data
        })()
    }, [null]);

    return (
        <div className="PortalUsersLogin">
            <Helmet>
                {/* <!-- TITLE --> */}
                <title>Reifly - Find The Best Jet PortalUsersLogin</title>
                {/* <!-- META --> */}
                <meta property="og:locale" content="en_US" data-react-helmet="true" />
                <meta property="og:type" content="article" data-react-helmet="true" />
                <meta property="og:image" content="article" data-react-helmet="true" />
                <meta property="og:url" content="https://www.mcaandco.com/" data-react-helmet="true" />
                <meta name="description" content="Our cash advance offers swift access to tailored funding solutions, empowering your business's growth and financial success. Explore opportunities today!" data-react-helmet="true" />
                <meta property="og:title" content="MCA & Co, Merchant Cash Advance" data-react-helmet="true" />
                <meta property="og:description" content="Our cash advance offers swift access to tailored funding solutions, empowering your business's growth and financial success. Explore opportunities today!" data-react-helmet="true" />
                <meta property="og:site_name" content="MCA & Co, Merchant Cash Advance" data-react-helmet="true" />
                <meta name="keywords" content="Financing, Business, Advance, Funding, Cash, Merchant, Capital, Loan, Credit, Repayment" data-react-helmet="true"></meta>
            </Helmet>

            <div className="PortalUsersLoginHeader">
                <a href="/">HandyBy</a>
                <span>
                    <h2>Are you a service professional?</h2>
                    <a href="/pro-sign-up">Sign in now.</a>
                </span>
            </div>
            <div className="PortalUsersLoginMain" ref={containerRef2}>
                {/* Email */}
                <div className="PortalUsersLoginMainPageEmail">
                    <h1>Log In with your email address.</h1>
                    <div className="PortalUsersLoginMainBox">
                        <div className="PortalUsersLoginMainBoxTextInput">
                            <h5>Email</h5>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Email"
                                style={Email ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}
                                // defaultValue={UserInfo.Email}
                                // Value={UserInfo.Email}
                                autoFocus
                                onChange={(e) => {
                                    UserInfo.Email = e.target.value.toLocaleLowerCase()
                                    setEmail(false)
                                    setRendder(a => !a)
                                }}
                            />
                        </div>
                        {Email ? <h6 style={{ "color": "#fc0a0a", "textAlign": "center" }}>Please enter a valid Email</h6> : null}
                        {IsEmailExistBoolen ? <h6 style={{ "color": "#fc0a0a", "textAlign": "center" }}>If you already have an account with this email, <a href="/login">please log in instead.</a></h6> : null}
                        <div className="PortalUsersLoginMainBoxButtons">
                            <button className="PortalUsersLoginMainBoxButtonsPrevius" onClick={() => {
                                navigate('/')
                            }}>Back</button>

                            <form className="PortalUsersLoginMainBoxButtonsNext" onClick={(e) => {
                                //    if (validator.isEmail(UserInfo.Email)) {
                                //     console.log("Valid Email :)");
                                //     window.scrollTo(0, 0)
                                //   } else {
                                //     console.log("Enter valid Email!");
                                //   }
                            }} onSubmit={sendEmail}>
                                <input type="hidden" name="email" defaultValue={UserInfo.Email} />
                                <input type="hidden" name="passcode" defaultValue={StorageCodeLocal} />
                                {LoadingEmail ?
                                    <div className="BookMainBoxButtonsLoading">
                                        <img src={require(`../../Images/loading.png`)} alt="Chimney Cleaning" />
                                    </div>
                                    :
                                    <input type="submit" value="Submit" />
                                }
                            </form>
                        </div>
                        <h2 >Don't have an accounnt? <a href="/sign-up"> Click to Sign Up</a></h2>

                    </div>
                </div>
                {/* Email > Confirmed Coded */}
                <div className="PortalUsersLoginMainPageConfirmedEmail">
                    <h1>Check your email to log in.</h1>
                    <div className="PortalUsersLoginMainBox">
                        <h2>If you already have an account with us please enter the 6-digit code we sent to {UserInfo.Email}.</h2>
                        <div className="PortalUsersLoginMainBoxTextInput">
                            <h5>Code</h5>
                            <input
                                type="number"
                                inputMode="numeric"
                                value={UserInfo.Code}
                                maxLength={6}
                                ref={inputRef}
                                pattern="^[0-9\b]+$"
                                style={{ "caretColor": "transparent" }}

                                onChange={(e) => {
                                    if (e.target.value.length == 6) {
                                        UserInfo.Code = e.target.value
                                        setEmailCode(true)
                                        setRendder(a => !a)
                                    }
                                    else {
                                        UserInfo.Code = e.target.value
                                        setRendder(a => !a)
                                    }
                                }}
                            />
                            <div className="PortalUsersLoginMainBoxTextInputBoxesList">
                                <div className="PortalUsersLoginMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 0 ? { "border": "2px solid red" } : null}>
                                    <h1 >{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(0) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 0 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersLoginMainBoxTextInputBoxLoadinig"></div>
                                </div>
                                <div className="PortalUsersLoginMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 1 ? { "border": "2px solid red" } : null}>
                                    <h1>{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(1) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 1 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersLoginMainBoxTextInputBoxLoadinig"></div>
                                </div>
                                <div className="PortalUsersLoginMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 2 ? { "border": "2px solid red" } : null}>
                                    <h1>{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(2) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 2 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersLoginMainBoxTextInputBoxLoadinig"></div>
                                </div>
                                <div className="PortalUsersLoginMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 3 ? { "border": "2px solid red" } : null}>
                                    <h1>{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(3) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 3 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersLoginMainBoxTextInputBoxLoadinig"></div>
                                </div>
                                <div className="PortalUsersLoginMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 4 ? { "border": "2px solid red" } : null}>
                                    <h1>{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(4) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 4 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersLoginMainBoxTextInputBoxLoadinig"></div>
                                </div>
                                <div className="PortalUsersLoginMainBoxTextInputBox" style={EmailCode && UserInfo.Code.length <= 5 ? { "border": "2px solid red" } : null}>
                                    <h1>{UserInfo && UserInfo.Code ? UserInfo.Code.charAt(5) : ""}</h1>
                                    <div style={UserInfo && UserInfo.Code.length == 5 || UserInfo.Code.length == 6 ? { "minWidth": "2px", "height": "40px", "backgroundColor": "#061257", "marginLeft": "-0px" } : null} className="PortalUsersLoginMainBoxTextInputBoxLoadinig"></div>
                                </div>
                            </div>
                        </div>
                        {EmailCode && UserInfo.Code !== JSON.stringify(StorageCodeLocal) ? <h6 style={{ "color": "#fc0a0a", "textAlign": "center" }}>Invalid Code</h6> : null}
                        <div className="PortalUsersLoginMainBoxButtons">
                            {LoadingEmail ?
                                <div className="BookMainBoxButtonsLoading">
                                    <img src={require(`../../Images/loading.png`)} alt="Chimney Cleaning" />
                                </div>
                                :
                                <button className="PortalUsersLoginMainBoxButtonsNext" onClick={() => {
                                    if (UserInfo.Code && UserInfo.Code.length && UserInfo.Code == StorageCodeLocal) {
                                        (async () => {
                                            setLoadingEmail(true)
                                            setRendder(a => !a)
                                            const res1 = await fetch(`https://bhocs-10ec.restdb.io/rest/handyby-users?q={"UserEmail":"${UserInfo.Email.toLocaleLowerCase()}"}&h={"$fields": {"UserEmail": 1, "FirstName": 1, "LastName": 1, "PhoneNumber": 1, "UserEmail": 1, "UserDateCreated": 1, "LastLoginUserDate": 1, "UserIP": 1,"UserID": 1,"UserAgent": 1,"UserProfilePicture": 1,"FirstProject": 1} }`, {
                                                method: 'GET',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    'apikey': '6714a668e2b4472fa2c2d036'
                                                }

                                            });
                                            const data1 = await res1.json()
                                            setLoadingEmail(false)
                                            localStorage.setItem("UserSessionn", JSON.stringify({
                                                // FirstName: data1[0].FirstName,
                                                // LastName: data1[0].LastName,
                                                // PhoneNumber: data1[0].PhoneNumber,
                                                // UserEmail: data1[0].Email,
                                                // UserDateCreated: data1[0].UserDateCreated,
                                                // LastLoginUserDate: data1[0].LastLoginUserDate,
                                                // UserIP: data1[0].UserIP,
                                                UserID: data1[0].UserID,
                                                // UserAgent: data1[0].UserAgent,
                                                // FirstProject: data1[0].FirstProject,
                                                // UserProfilePicture: null,
                                            }))
                                            setUpdateApp(a => !a)
                                            showsetNotificationType('login')
                                            showsetNotification(true)
                                            navigate('/account/dashboard')
                                        })()

                                    } else {
                                        setEmailCode(true)
                                        setRendder(a => !a)
                                    }


                                }}>Verify and Log In</button>
                            }

                        </div>
                        <h2>If you don't have an account with us please <a href="/sign-up">Click to Sign Up.</a></h2>

                    </div>
                    <h4>Don't see the email? Check your junk folder, If you still <br /> can't see pleaes start over</h4>
                    <a href="/login">Start over</a>

                </div>
            </div>

        </div >
    )
}

